import api from "../axios/axios-config";

export const getCategoryCost = async () => {
  try {
    let response = await api.get("categoryCost/listOfCategoryCost");
    return response?.data?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const createCategoryCost = async (data) => {
  try {
    let response = await api.post("categoryCost/createCategoryCost", data);

    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateCategoryCost = async (dataId, data) => {
  try {
    let response = await api.post("categoryCost/updateCategoryCost", {
      dataId,
      ...data,
    });

    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};
